import React, { Component } from 'react'
import S from 'shorti'
import { Button, FormControl } from 'react-bootstrap'
import style from './style'
import Dropzone from 'react-dropzone'
import ListingSearch from '../ListingSearch'
import Textarea from 'react-textarea-autosize'
class Step extends Component {
  onDrop(key, accepted_files, rejected_files) {
    this.props.uploadMedia(key, accepted_files)
  }
  handleChange(key, e) {
    this.props.editText(key, e.target.value)
  }
  saveWebsite() {
    this.props.saveWebsite()
  }
  handleMLSInputChange(key, e) {
    this.props.editText(key, e.target.value) 
    this.props.seachListings(e.target.value)
  }
  handleListingClick(listing) {
    this.props.selectListing(listing)
  }
  handleRemoveSearchButtonClick() {
    this.props.removeSearchListings() 
  }
  handleListingGalleryImageClick(key, image_url) {
    this.props.addGalleryImage(key, image_url)
  }
  goToDomains() {
    const data = this.props.data
    const website= data.website
    window.location.href = `/domains${window.location.search}&domain=${website.hostnames[0]}`
  }
  removeAttr(attribute) {
    this.props.removeAttr(attribute)
  }
  getInput(attribute) {
    const data = this.props.data
    switch (attribute.type) {
      case 'Media':
        return (
          <div style={ S('mb-20') }>
            <div style={ S('mb-10') }>{ attribute.title }</div>
            <Dropzone style={ S('w-250 h-250 border-3-dashed-ccc') } onDrop={this.onDrop.bind(this, attribute.key)} multiple={false}>
              <div style={ S(`text-center pt-100 bg-url(${attribute.value ? attribute.value : ''}) bg-cover w-244 h-244 absolute`) }>
                <Button bsStyle="primary">Upload</Button>
              </div>
            </Dropzone>
            <Button onClick={ this.removeAttr.bind(this, attribute) }>Remove</Button>
          </div>
        )
      case 'text':
        return (
          <div>
            <div style={ S('mb-10') }>{ attribute.title }</div>
            <FormControl key={`key-${attribute.key}`} style={ style.input } type="text" onChange={this.handleChange.bind(this, attribute.key)} value={ attribute.value }></FormControl>
          </div>
        )
      case 'textarea':
        return (
          <div>
            <div style={ S('mb-10') }>{ attribute.title }</div>
            <Textarea key={`key-${attribute.key}`} style={ { ...style.input, ...S('h-100 w-100p p-10 br-4 minh-100'), resize: 'none' } } componentClass="textarea" onChange={this.handleChange.bind(this, attribute.key)} value={ attribute.value }></Textarea>
          </div>
        )
      case 'VideoLink':
        return (
          <div>
            <div style={ S('mb-10') }>{ attribute.title }</div>
            <FormControl key={`key-${attribute.key}`} style={ style.input } type="text" onChange={this.handleChange.bind(this, attribute.key)} value={ attribute.value }></FormControl>
          </div>
        )
      case 'listing':
        const listings_area_style = {
          overflowY: 'scroll',
          ...S('w-340 maxh-300 bg-fff color-333 absolute t-250 z-100')
        }
        let listing_area
        let close_search_button
        if (data.listings) {
          listing_area = (
            <div style={ listings_area_style }>
              <ListingSearch listings={ data.listings } handleListingClick={ this.handleListingClick.bind(this) }/>
            </div>
          )
          close_search_button = (
            <div style={ S('absolute t-19 r-10 pointer') } onClick={ this.handleRemoveSearchButtonClick.bind(this) }>&times;</div>
          )
        }
        return (
          <div>
            <div style={ S('mb-10') }>{ attribute.title }</div>
            <div style={ S('relative') }>{ close_search_button }</div>
            <FormControl placeholder="Search MLS# or Address" key={`key-${attribute.key}`} style={ style.input } type="text" value={ attribute.value } onClick={ this.handleMLSInputChange.bind(this, attribute.key) } onChange={ this.handleMLSInputChange.bind(this, attribute.key) }></FormControl>
            { listing_area }
          </div>
        )
      case 'listing_images':
        let images_area
        if (data.website.listing) {
          images_area = data.website.listing.gallery_image_urls.map(image_url => {
            let image_style = S(`w-100 h-100 bg-cover bg-center pull-left bg-url(${image_url}) pointer relative`)
            let check_mark
            if (data.website.attributes && data.website.attributes[attribute.key] && data.website.attributes[attribute.key] === image_url) {
              image_style = {
                ...image_style,
                ...S('border-3-solid-2196f3')
              }
              check_mark = (
                <div style={ S('absolute b-5 r-5') }><i className="fa fa-check" style={ S('color-2196f3 font-30') }></i></div>
              )
            }
            return (
              <div key={ image_url } onClick={ this.handleListingGalleryImageClick.bind(this, attribute.key, image_url) } style={ image_style }>
                { check_mark }
              </div>
            )
          })
        }
        return (
          <div>
            <div style={ S('mb-10') }>{ attribute.title }</div>
            { images_area }
            <div className="clearfix"></div>
          </div>
        )
      default:
        return
    }
  }
  // goToEditPayment() {
  //   const data = this.props.data
  //   window.location.href = `/domains${window.location.search}&show_card_form=true&domain=${data.website.hostnames[0]}`
  // }
  getButtons() {
    const data = this.props.data
    const steps = data.steps
    const next_step = steps[data.step]
    const website = data.website
    let back_button
    if (data.step !== 1) {
      back_button = (
        <Button style={ S(`bg-f67608 border-none color-fff w-${!next_step ? '30' : '45'}p h-40`) } onClick={ this.props.goToStep.bind(this, data.step - 1) }>
          <i className="fa fa-chevron-left"></i> Back
        </Button>
      )
    }
    let next_button
    if (next_step) {
      next_button = (
        <Button style={ S(`bg-f67608 border-none color-fff w-${!back_button ? '100' : '45'}p h-40 pull-right`) } onClick={ this.props.goToStep.bind(this, data.step + 1) }>
          Next <i className="fa fa-chevron-right"></i>
        </Button>
      )
    }
    let domains_button
    if (!next_step) {
      if (website && website.hostnames && website.hostnames.length) {
        domains_button = (
          <Button className={ data.saving_website ? 'disabled' : '' } onClick={ this.saveWebsite.bind(this) } style={ S('bg-f67608 border-none color-fff w-65p h-40 pull-right') }>
            { data.saving_website ? 'Saving...' : 'Save' }
          </Button>
        )
      } else {
        domains_button = (
          <Button className={ data.saving_website ? 'disabled' : '' } onClick={ this.saveWebsite.bind(this) } style={ S('bg-f67608 border-none color-fff w-65p h-40 pull-right') }>
            { data.saving_website ? 'Saving...' : 'Save and go to domains' } <i className="fa fa-chevron-right"></i>
          </Button>
        )
      }
    }
    // Show overview Save and Back
    if (data.website && data.website.hostnames) {
      return (
        <div>
          <Button style={ S(`bg-263445 border-1-solid-8696a4 color-8696a4 w-30p h-40`) } onClick={ this.props.showOverview.bind(this) }>
            Cancel
          </Button>
          <Button className={ data.saving_website ? 'disabled' : '' } onClick={ this.saveWebsite.bind(this) } style={ S('bg-f67608 border-none color-fff w-65p h-40 pull-right') }>
            { data.saving_website ? 'Saving...' : 'Save' }
          </Button>
        </div>
      )
    }
    return (
      <div>
        { back_button }
        { next_button }
        { domains_button }
      </div>
    )
  }
  render() {
    const data = this.props.data
    const steps = data.steps
    const step = steps[data.step - 1]
    const attributes = step.attributes
    // If already saved website
    if (data.website && data.website.hostnames && data.show_overview) {
      return (
        <div style={ S('mb-20 mt-35') }>
          { 
            steps.map((step, i) => {
              return <div style={ { ...S('pointer bg-3B4857 p-15 relative'), borderBottom: '1px solid #273546' } } key={`overview-${i}`} onClick={ this.props.goToStep.bind(this, (i + 1)) }>
                <div style={ S('font-15') }>{ step.title }</div>
                <div style={ S('color-8E959E') }>{ step.attributes[0].description }</div>
                <i style={ S('absolute r-10 t-15') } className="fa fa-chevron-right"></i>
              </div>
            })
          }
          <div style={ S('p-15 mt-20') }>MANAGE</div>
          <div style={ { ...S('pointer bg-3B4857 p-15 relative'), borderBottom: '1px solid #273546' } } onClick={ this.props.showEditDomainsPanel.bind(this) }>
            <div style={ S('font-15') }>Domains</div>
            <i style={ S('absolute r-10 t-15') } className="fa fa-chevron-right"></i>
          </div>
        </div>
      )
    }
    let progress_bar = (
      <div style={ S('w-100p h-4 bg-34475e mb-10 mt-20n br-3') }>
        <div style={ S(`w-${Math.floor((data.step / steps.length) * 100)}p bg-6488b5 h-4 br-3`) }></div>
      </div>
    )
    let title = (
      <div style={ S('mb-20 ml-20') }>
        <span style={ S('font-32') }>{ step.title }</span>
      </div>
    )
    if (data.website && data.website.hostnames) {
      progress_bar = ''
      title = (
        <div style={ { ...S('mb-20 h-50 pointer bg-3B4857 p-13 relative'), borderBottom: '1px solid #273546' } } onClick={ this.props.showOverview.bind(this) }>
          <i className="fa fa-chevron-left"></i>&nbsp;&nbsp;&nbsp;<span style={ S('font-17') }>{ step.title }</span>
        </div>
      )
    }
    // If edit domains
    if (data.show_edit_domains_panel) {
      return (
        <div style={ S('mt-60') }>
          <div style={ { ...S('mb-20 h-50 pointer bg-3B4857 p-13 relative'), borderBottom: '1px solid #273546' } } onClick={ this.props.showOverview.bind(this) }>
            <i className="fa fa-chevron-left"></i>&nbsp;&nbsp;&nbsp;<span style={ S('font-17') }>Domains</span>
          </div>
          <div>
            <div style={ S('p-15') }>
              <div style={ S('mb-10 font-20') }>Option 1</div>
              <div style={ S('mb-20') }>I need to buy a domain.</div>
              <div style={ S('mb-20') }>
                <Button style={ S(`bg-f67608 color-fff border-none w-100p h-40`) } onClick={ this.goToDomains.bind(this) }>Purchase Domain</Button>
              </div>
              <div style={ S('mb-10 font-20') }>Option 2</div>
              <div style={ S('mb-20') }>I have an existing domain.</div>
            </div>
            {
              data.website.hostnames.map((hostname, i) => {
                return (
                  <div style={ S('p-15 pb-10 pt-10 font-18 relative') } key={`key-hostname-${i}`}>
                    <div>{ hostname }</div>
                    {
                      data.website.hostnames && data.website.hostnames.length > 1 &&
                      <span style={ S('absolute t-10 r-27 color-fff fw-100') } className="close" onClick={ this.props.deleteDomain.bind(this, hostname) }>&times;</span>
                    }
                  </div>
                )
              })
            }
            {
              data.added_domain_fields &&
              data.added_domain_fields.map((field, i) => {
                return (
                  <div style={ S('pl-15 pr-15 relative') } key={`key-hostname-${i}`}>
                    <FormControl type="text" style={ style.input } value={ field.value } onChange={ this.props.addDomainValue.bind(this, field.id) }/>
                    <span style={ S('absolute t-17 r-27 color-fff fw-100') } className="close" onClick={ this.props.removeDomainField.bind(this, field.id) }>&times;</span>
                  </div>
                )
              })
            }
            <div style={ S('p-15 pt-0') }>
              <Button style={ S(`bg-263445 border-1-dashed-8696a4 color-8696a4 w-100p h-40`) } onClick={ this.props.addDomainField.bind(this) }>
                <i className="fa fa-plus"></i>&nbsp;&nbsp;Add Another
              </Button>
            </div>
            <div style={ S('p-15') }>
              <Button style={ S(`bg-263445 border-1-solid-8696a4 color-8696a4 w-30p h-40`) } onClick={ this.props.showOverview.bind(this) }>
                Cancel
              </Button>
              <Button className={ data.saving_website ? 'disabled' : '' } onClick={ this.saveWebsite.bind(this) } style={ S('bg-f67608 border-none color-fff w-65p h-40 pull-right') }>
                { data.saving_website ? 'Adding...' : 'Add domain' }
              </Button>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div>
        <div style={ S('p-30') }>{ progress_bar }</div>
        { title }
        <div style={ S('p-30') }>
          {
            attributes.map((attribute, i) => {
              return (
                <div key={`attr${i}`}>
                  { this.getInput(attribute) }
                  <div>
                    <div style={ S('mb-20 op-.5') }>{ attribute.description }</div>
                  </div>
                </div>
              )
            })
          }
          <div style={ S('absolute w-340') }>
            { this.getButtons() }
          </div>
        </div>
      </div>
    )
  }
}
export default Step


// WEBPACK FOOTER //
// ./src/components/Partials/EditBar/Step.js